import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {connect} from 'react-redux';
import PaymentOptionsLoadingStatus from '../enums/PaymentOptionsLoadingStatus';
import Status from '../enums/Status';
import selectAvailablePaymentOption from '../v2/actions/paymentActions/selectAvailablePaymentOption';
import getHasValidAvailablePaymentOption
from '../v2/selectors/PaymentOptionSelectors/getHasValidAvailablePaymentOption';
import getPaymentOptionsLoadingStatus from '../v2/selectors/PaymentOptionSelectors/getPaymentOptionsLoadingStatus';
import {getSelectedPaymentOptionIndex} from '../v2/selectors/PaymentOptionSelectors/getSelectedPaymentOptionIndex';
import {
  getPaymentOptionDisabledStatuses,
  getPaymentOptionHiddenStatuses,
} from '../v2/selectors/PaymentOptionSelectors/PaymentOptionDisabledSelectors';
import {getSettings} from '../v2/selectors/selectors';

export function PaymentHiddenOrDisabledListener(props) {
  useEffect(() => {
    if ((props.isCurrentOptionUnavailable || props.isCurrentOptionHidden)
      && !props.isOrderSummaryLoading
      && props.hasAvailableOption
      && (!props.deferPaymentOptionPreSelection || props.paymentOptionsLoadingStatus !== PaymentOptionsLoadingStatus.LOADING)) {
      props.selectAvailablePaymentOption();
    }
  }, [props.isCurrentOptionUnavailable, props.isCurrentOptionHidden, props.isOrderSummaryLoading, props.hasAvailableOption, props.deferPaymentOptionPreSelection, props.paymentOptionsLoadingStatus]);
  
  return null;
}

PaymentHiddenOrDisabledListener.propTypes = {
  isCurrentOptionUnavailable: PropTypes.bool.isRequired,
  isCurrentOptionHidden: PropTypes.bool.isRequired,
  isOrderSummaryLoading: PropTypes.bool.isRequired,
  hasAvailableOption: PropTypes.bool.isRequired,
  deferPaymentOptionPreSelection: PropTypes.bool.isRequired,
  paymentOptionsLoadingStatus: PropTypes.symbol.isRequired,
  selectAvailablePaymentOption: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const selectedPaymentOptionIndex = getSelectedPaymentOptionIndex(state);
  return {
    isCurrentOptionUnavailable: getPaymentOptionDisabledStatuses(state)[selectedPaymentOptionIndex],
    isCurrentOptionHidden: getPaymentOptionHiddenStatuses(state)[selectedPaymentOptionIndex],
    hasAvailableOption: getHasValidAvailablePaymentOption(state),
    isOrderSummaryLoading: state.orderSummary?.status === Status.UPDATING,
    paymentOptionsLoadingStatus: getPaymentOptionsLoadingStatus(state),
    deferPaymentOptionPreSelection: getSettings(state).should_defer_payment_option_preselection,
  };
};

export default connect(mapStateToProps, {selectAvailablePaymentOption})(PaymentHiddenOrDisabledListener);
